import styled from 'styled-components'
import { theme } from '../../styles/theme'
import { mq, ScreenSize } from '../../styles/mq'
export const TimelineContainer = styled.div<{ $isOpen: boolean }>`
  ${(props) => (props.$isOpen ? 'height: auto' : 'height: 0')};
  overflow: hidden;
  position: relative;
`
export const TimelineAnchor = styled.div<{ $scrollUp: boolean }>`
  position: absolute;
  //top: -6rem;
  ${(props) => (props.$scrollUp ? 'top: -12rem' : 'top: -6rem')};
  ${mq.smallOnly} {
    ${(props) => (props.$scrollUp ? 'top: -10rem' : 'top: -4.9rem')};
  }
  ${mq.large} {
    ${(props) => (props.$scrollUp ? 'top: -6rem' : 'top: 0')};
  }
`
export const TimelineTitle = styled.div`
  position: relative;
  width: 100%;
  z-index: 1000;

  ${mq.large} {
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: calc(100% - 1px);
      width: calc((100% - 117.8rem) / 2 + 30rem);
      height: 5rem;
      background: linear-gradient(rgba(22, 31, 36, 1), rgba(22, 31, 36, 0));
    }
    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 100%;
      width: calc((100% - 117.8rem) / 2 + 30rem);
      height: 5rem;
      background: linear-gradient(rgba(22, 31, 36, 0), rgba(22, 31, 36, 1));
    }
  }
  ${mq.xlarge} {
    &::before {
      width: calc((100% - 117.8rem) / 2 + 36rem);
    }
    &::after {
      width: calc((100% - 117.8rem) / 2 + 36rem);
    }
  }
  img {
    display: block;
    width: 100%;
    filter: grayscale(1);
    opacity: 0.85;
  }
  h2 {
    position: absolute;
    bottom: 2rem;
    /*left: 2rem;*/
    line-height: 3rem;
    padding-right: 6rem;
    font-size: 2.8rem;
    width: 100%;
    max-width: ${ScreenSize.MD / 10}rem;
    transform: translateX(6rem);
    padding-right: 8rem;
    ${mq.medium} {
      max-width: 740px;
      transform: translateX(8rem);
      padding-right: 10rem;
    }
    ${mq.large} {
      max-width: calc(740px - 8.4rem);
      font-size: 4rem;
      margin-bottom: 2rem;
      line-height: 1.2;
    }
    ${mq.xlarge} {
      max-width: calc(740px - 18.4rem);
      font-size: 5rem;
      margin-bottom: 3rem;
    }
    left: 0;
    right: 0;
    margin: auto;

    span {
      position: absolute;
      left: -4rem;
      ${mq.large} {
        top: 1rem;
      }
      font-size: 2.1rem;
      width: 3rem;
      height: 3rem;
      padding-top: 0.2rem;
      display: flex;
      justify-content: center;
      align-items: center;
      background: ${theme.colors.orange};
      border-radius: 50%;
      ${mq.xlarge} {
        font-size: 2.4rem;
        width: 3.6rem;
        height: 3.6rem;
        left: -4.4rem;
      }
    }

    strong {
      display: block;
      font-size: 0.6em;
      font-weight: normal;
      line-height: 1.4;
      padding-top: 0.2em;
    }
  }
`
export const TimelineTitleMask = styled.div`
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: calc((100% - 117.8rem) / 2 + 30rem);
  height: 100%;
  background: ${theme.colors.background};
  ${mq.large} {
    display: block;
  }
  ${mq.xlarge} {
    width: calc((100% - 117.8rem) / 2 + 36rem);
  }
`
export const TimelineLine = styled.div`
  position: absolute;
  width: 100%;
  max-width: ${ScreenSize.MD / 10}rem;
  ${mq.medium} {
    max-width: 740px;
  }
  ${mq.large} {
    max-width: calc(${ScreenSize.MD / 10}rem + 30rem);
  }
  ${mq.xlarge} {
    max-width: calc(${ScreenSize.MD / 10}rem + 40rem);
  }
  margin: 0 auto;
  top: 0;
  top: calc(50vw - 4rem);
  ${mq.large} {
    top: calc(50vw - 5rem);
  }
  left: 0;
  right: 0;
  bottom: 2.1rem;
  &::before {
    position: absolute;
    content: '';
    height: 100%;
    display: block;
    border-left: 1px dashed ${theme.colors.text};
    left: 3.5rem;
    ${mq.medium} {
      left: 5.5rem;
    }
    ${mq.large} {
      left: 31.5rem;
    }
    ${mq.xlarge} {
      left: 41.5rem;
    }
  }
`
export const TimelineIntro = styled.div`
  font-family: 'Skolar PE';
  line-height: 2.4rem;
  padding-left: 4rem;
  margin: 2rem 0;
  ${mq.xlarge} {
    font-size: 2rem;
    line-height: 3rem;
    margin: 3rem 0;
  }
`
export const TimelineSubtitle = styled.h3`
  position: relative;
  font-weight: 800;
  font-size: 1.7rem;
  font-family: 'Skolar Sans PE condensed';
  margin-top: 2rem;
  margin-bottom: 1rem;
  ${mq.xlarge} {
    font-size: 2rem;
    margin-top: 3rem;
    margin-top: 3rem;
    margin-bottom: 1.5rem;
  }
  &::before {
    content: '';
    position: absolute;
    top: 0;
    ${mq.xlarge} {
      top: 0.4rem;
    }
    left: -3.5rem;
    width: 2.1rem;
    height: 2.1rem;
    border-radius: 50%;
    background: ${theme.colors.text};
  }
`
export const TimelineContent = styled.div`
  font-family: 'Skolar PE';
  padding-left: 4rem;
  font-size: 1.6rem;
  line-height: 2.4rem;
  margin-bottom: 2rem;
  ${mq.xlarge} {
    font-size: 2rem;
    line-height: 3rem;
  }
  button {
    color: ${theme.colors.orange};
    background: none;
    border: none;
    border-radius: none;
    font-family: 'Skolar Sans PE condensed';
    font-size: 1.6rem;
    text-transform: uppercase;
    font-weight: 800;
    padding: 0;
    cursor: pointer;
    ${mq.xlarge} {
      font-size: 2rem;
    }
  }
  img {
    width: 100%;
  }
  iframe {
    width: 100%;
    aspect-ratio: 16/9;
    border: none;
    margin: 2rem 0;
    display: block;
    ${mq.xlarge} {
      margin: 3rem 0;
    }
  }
  a {
    color: ${theme.colors.text};
    text-decoration: none;
    border-bottom: 1px solid ${theme.colors.text};
  }
  p {
    margin-top: 1rem;
    margin-bottom: 2rem;
    ${mq.xlarge} {
      margin-top: 1.5rem;
      margin-bottom: 3rem;
    }
  }
  .last_paragraph {
    margin-left: -3rem;
    padding-left: 3rem;
    margin-top: -2rem;
    padding-bottom: 6rem;
    margin-bottom: 0;
    ${mq.medium} {
      padding-bottom: 10rem;
    }
    padding-top: 2rem;
    background: ${theme.colors.background};
  }
`
export const TimelineReadmore = styled.div`
  transition: max-height 2s;
`
export const TimelineImage = styled.div`
  width: 100%;
  margin: 2rem 0;
  ${mq.xlarge} {
    margin: 3rem 0;
  }
  span {
    font-size: 1.5rem;
    line-height: 2rem;
    font-style: italic;
    display: block;
    ${mq.xlarge} {
      font-size: 1.8rem;
      line-height: 2.4rem;
    }
  }
`
